<template>
	<div>
		<myheader headTitle="新的申请"></myheader>
		<div class="all_list_main">
			<div class="all_list_content_nopadding">
				<div>
					<div v-for="(item,index) in list" :key="index">
						<div class="flex" style="height: 3.2rem;padding: 0 .5rem;background-color: white;">
							<img src="@/assets/images/selected.svg" style="height:2.2rem;margin: .5rem 0;" />
							<div style="display: inline-block;width:50%;margin: .5rem;">
								<div class="all_height_line12 text14 textcolor333 font_weight_700">
									{{item.staffName}}
								</div>
								<div class="all_height_line10 text12 textcolor999">
									{{item.userName}}
								</div>
							</div>
							<button v-if="!item.corpId" class="text12 all_button all_height_line14 bmain_active"
								style="width: 15%;margin: .9rem .5rem;" @click="rejectClick(item)">驳回</button>
							<button v-if="!item.corpId" class="text12 all_button all_height_line14 bmain_active"
								style="width:15%;margin: .9rem 0;" @click="agreeClick(item)">同意</button>
							<span v-if="item.corpId" class="text12 textcolor666 all_height_line14 all_text_right"
								style="width:30%;margin: .9rem 0;">已添加</span>
						</div>
						<div class="horizontal_line"></div>
					</div>
				</div>
			</div>
		</div>
		<van-popup v-model:show="showBottom" :overlay="true" position="bottom">
			<div>
				<div v-if="agreeOrReject === 1">
					<div style="margin: .5rem .8rem;" class="text16 textcolor333">设置用户权限</div>
					<div class="horizontal_line"></div>
					<div style="margin: 1rem .8rem;"><van-checkbox class="text14 textcolor333"
							v-model="isSigner">签名人</van-checkbox></div>
					<div class="horizontal_line"></div>
					<div style="margin: 1rem .8rem;"><van-checkbox class="text14 textcolor333"
							v-model="isSealer">盖章人</van-checkbox></div>
				</div>
				<div v-if="agreeOrReject === 0">
					<div style="margin: .5rem .8rem;" class="text16 textcolor333">驳回原因</div>
					<div class="horizontal_line"></div>
					<div class="all_details_content_card margin_top_2">
						<textarea class="area text12 textcolor333" placeholder="请输入驳回原因" v-model="denyWord"
							maxlength="100" style="overflow-y: auto;height: 5rem;">
							</textarea>
					</div>
				</div>
				<div class="horizontal_line"></div>
				<div>
					<button style="width: 40%;margin: 5%;" class="all_button20 text16 backgroundC_ccc bwhite_ative"
						@click="showBottom = false">取消</button>
					<button style="width: 40%;margin: 5%;" class="all_button20 text16 bmain_active"
						@click="sumbit()">确定</button>
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Dialog,
		Checkbox,
		CheckboxGroup
	} from 'vant'
	export default {
		components: {
			[Checkbox.name]: Checkbox,
			[CheckboxGroup.name]: CheckboxGroup,
		},
		data() {
			return {
				//弹窗
				showBottom: false,
				//企业id
				corpId: '',
				//申请加入列表
				list: [],
				//登录id
				staffId: this.$store.state.loginInfo.staffId,
				//选择的item
				selectItem: null,
				//组织机构多选结果
				checkResult: [],
				//用户组织机构列表
				checkBoxList: [],
				//
				isSealer: false,
				isSigner: false,
				//驳回原因
				denyWord: '',
				//同意 1 驳回 0
				agreeOrReject: 1,
				//
				locallist: null,
				//
				networklist: null,
				//
				sqlName: 'memberInfoTwo',
			}
		},
		methods: {
			//弹窗隐藏
			dimiss() {
				this.showBottom = false
				this.checkResult = []
			},
			//结果提交
			sumbit() {
				if (this.agreeOrReject) {
					this.agreeJoin(this.selectItem, this.agreeOrReject)
				} else {
					if (!this.denyWord) {
						this.$Toast('请输入驳回原因！')
						return
					}
					this.agreeJoin(this.selectItem, this.agreeOrReject, this.denyWord)
				}
				this.showBottom = false
			},
			//同意弹窗
			agreeClick(item) {
				this.selectItem = item
				this.showBottom = true
				this.isSealer = false
				this.isSigner = false
				this.agreeOrReject = 1
			},
			//驳回弹窗
			rejectClick(item) {
				this.selectItem = item
				Dialog.confirm({
						title: '提示',
						message: '确定驳回加入企业申请？',
						confirmButtonText: '确定',
						confirmButtonColor: '#0277FC'
					})
					.then(() => {
						this.showBottom = true
						this.denyWord = ''
						this.agreeOrReject = 0
					})
			},
			//同意加入企业
			agreeJoin(item, passed, reason = '') {
				let that = this
				this.$store.dispatch(this.$LoadShow, true)
				this.$post('/corp/m/api/auditJoinApply', {
					applyId: item.applyId,
					isSealer: this.isSealer,
					isSigner: this.isSigner,
					passed: passed,
					reason: reason
				}).then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success) {
						this.$Toast('操作成功！')
						if (window.plus && passed) {
							this.addMemberToLocal(item)
						}
						this.getApplyMemberList()
					} else {
						this.$Toast(res.message || '操作失败！')
					}
				})
			},
			//获取申请加入该企业的用户列表
			getApplyMemberList() {
				this.$store.dispatch(this.$LoadShowLevel, true)
				this.$get('/corp/m/api/getJoinApplies', {
					corpId: this.corpId
				}).then((res) => {
					this.$store.dispatch(this.$LoadShowLevel, false)
					if (res.success && res.data) {
						this.networklist = res.data.filter((item) => {
							return item.staffId !== this.$store.state.userInfo.staffId
						})
						//this.list = this.networklist.concat(this.locallist)
					}
					this.getLocalMemberList()
				}).catch(err => {
					this.$store.dispatch(this.$LoadShowLevel, false)
					this.getLocalMemberList()
				})
			},
			//
			operateList() {
				let that = this
				if (this.locallist && Array.isArray(this.locallist) && this.locallist.length > 0) {
					this.locallist.forEach((local) => {
						that.networklist = that.networklist.filter((item) => {
							return item.applyId !== local.applyId
						})
					})
					if (this.networklist && Array.isArray(this.networklist) && this.networklist.length > 0) {
						this.list = this.networklist.concat(this.locallist)
					} else {
						this.list = this.locallist
					}
				} else {
					if (this.networklist && Array.isArray(this.networklist) && this.networklist.length > 0) {
						this.list = this.networklist
					} else {
						this.list = []
					}
				}
			},
			//
			addMemberToLocal(item) {
				let that = this
				let time = this.Tool.dateFormate(Date(), 'yyyy-MM-dd hh:mm')
				let sqlStr = `insert into ${that.sqlName} values('${that.staffId}','${that
						.corpId}','${item.applyId}','${item.staffId}','${item
						.staffName}','${item.userName}','${time}')`
				plus.sqlite.executeSql({
					name: 'mydb',
					sql: sqlStr,
					success: function(data) {
						console.log('插入成功!');
					},
					fail: function(e) {
						console.log('插入失败!', e);
					}
				})
			},
			//获取本地已添加过的成员
			getLocalMemberList() {
				let that = this
				if (window.plus) {
					let createSql =
						`create table if not exists ${that.sqlName}("mystaffId" CHAR(110),"corpId" CHAR(110),"applyId" CHAR(100),"staffId" CHAR(110),"staffName" CHAR(100),"userName" CHAR(100),"createTime" CHAR(100))`
					let searchSql =
						`select * from ${that.sqlName} where mystaffId='${that.staffId}' and corpId='${that.corpId}'`
					//console.log('sql---=', createSql, searchSql)
					plus.sqlite.executeSql({
						name: 'mydb',
						sql: createSql,
						success: function() {
							plus.sqlite.selectSql({
								name: 'mydb',
								sql: searchSql,
								success: function(data) {
									//console.log(data);
									//that.list = that.list.concat(data);
									that.locallist = data
									that.operateList()
								},
								fail: function(e) {
									that.operateList()
									console.log('查询失败!');
									console.log(e);
								}
							});
						},
						fail: function(e) {
							that.operateList()
							console.log('创建数据库失败!');
							console.log(e);
						}
					});
				} else {
					that.operateList()
				}
			},
			//
			closeSqLite() {
				if (window.plus) {
					plus.sqlite.closeSqLite({
						name: 'mydb',
						success: function(e) {

						},
						fail: function(e) {

						},
					})
				}
			},
			//初始化
			init() {
				this.corpId = this.$route.query.corpId
				let that = this
				if (window.plus) {
					plus.io.requestFileSystem(plus.io.PRIVATE_DOC, function(fs) {
						fs.root.getFile('zsh_esign.db', {
							create: true
						}, function(fileEntry) {
							if (plus.sqlite.isOpenDatabase({
									name: 'mydb',
									path: '_doc/zsh_esign.db',
								})) {} else {
								plus.sqlite.openDatabase({
									name: 'mydb',
									path: '_doc/zsh_esign.db',
									success: function() {
										//that.getLocalMemberList()
									},
									fail: function(e) {
										console.log('打开数据库失败!');
										console.log(e);
									},
								});
							}
						});
					});
				}
			},
		},
		mounted() {
			this.init()
			this.getApplyMemberList()
		},
		beforeDestroy() {

		}
	}
</script>

<style scoped lang="scss">
	@import "../../../styles/global.css";
</style>